const HTTP_STATUS_FALLBACKS = {
  413: 'This document is too large to analyze. Please upload a smaller file.',
  422: 'The document could not be analyzed. Please try a different file.',
  429: 'Too many requests. Please wait a moment and try again.',
  500: 'The server encountered an error. Please try again.',
  502: 'The analysis service is temporarily unavailable. Please try again.',
  503: 'The analysis service is temporarily unavailable. Please try again in a moment.',
  504: 'The analysis request timed out. Please try again.',
};

/** Prefer API `message` (user-facing) then `detail`, never raw axios "status code NNN". */
function axiosErrorMessage(error, fallback = 'Request failed') {
  const apiMessage = error?.response?.data?.message || error?.response?.data?.detail;
  if (typeof apiMessage === 'string' && apiMessage.trim()) return apiMessage;
  const statusFallback = HTTP_STATUS_FALLBACKS[error?.response?.status];
  if (statusFallback) return statusFallback;
  const raw = error?.message;
  if (typeof raw === 'string' && raw && !/status code \d+/i.test(raw)) return raw;
  return fallback;
}

module.exports = {
  axiosErrorMessage,
  HTTP_STATUS_FALLBACKS,
};
